import {Redirect, Route, Switch, useLocation} from "react-router-dom";

import Home from "../pages/Home";
import Step1 from "../pages/Step1";
import Scan from "../pages/Scan";
import Step2 from "../pages/Step2";
import {useContext, useEffect, useState} from "react";
import {AppContext} from "../context/AppContext";
import ErrorMessage from "../components/common/ErrorMessage";
import {SESSION_EXPIRED} from "../libs/messages";


const Routes = () => {
    const location = useLocation()
    const {appData, setAppData} = useContext(AppContext)

    const [sessionExpired, setSessionExpired] = useState(window.sessionStorage.getItem('sessionExpired') === 'true')

    useEffect(() => {
        const popstateListener = () => {
            window.sessionStorage.setItem('sessionExpired', 'true')
            setSessionExpired(true)
        };
        window.addEventListener('popstate', popstateListener);
        return () => {
            window.removeEventListener('popstate', popstateListener);
        };
    }, [location]);


    useEffect(() => {
        let timer;

        timer = setTimeout(() => {
            setSessionExpired(true);
            setAppData(null);
            console.info('Session has expired due to inactivity.')
        }, 5 * 60 * 1000);


        return () => {
            clearTimeout(timer);
        };
    }, []);

    const ProtectedRoute = ({component: Component, ...rest}) => (
        <Route
            {...rest}
            render={props =>
                appData && appData.hasOwnProperty('sessionID') ? (
                    <Component {...props} />
                ) : (
                    <Redirect to="/error"/>
                )
            }
        />
    );


    return !sessionExpired ? (<Switch>
        <Route path="/scan/:eventID/:qrCodeID" component={Scan}/>
        <Route path="/scan/:qrCodeID" component={Scan}/>
        <Route path="/error" component={Home}/>
        <ProtectedRoute path="/step/1" component={Step1}/>
        <Route path="/step/2" component={Step2}/>
        <Route path="*" render={() => <Redirect to={`/error`}/>}/>
    </Switch>) : (<ErrorMessage message={SESSION_EXPIRED}/>)
};


export default Routes;
